var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEstimatorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "470C18EA-2ECE-444E-8321-0650ECD23AF2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "17.0_Estimator-Tool_01",
    transform: "translate(-1354.000000, -798.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    transform: "translate(1340.000000, 784.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.Icons-/-Basic-/-Line-/-Chat",
    transform: "translate(14.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,1.33333333 C19.9176042,1.33333333 23.6007708,2.85895312 26.3709375,5.6290625 C29.1410469,8.39922917 30.6666667,12.0823958 30.6666667,16 C30.6666667,19.9176042 29.1410469,23.6007708 26.3709375,26.3709375 C23.6007708,29.1410469 19.9176042,30.6666667 16,30.6666667 C15.5253958,30.6666667 15.140625,30.2818958 15.140625,29.8072917 C15.140625,29.3326875 15.5253958,28.9479167 16,28.9479167 C23.1395156,28.9479167 28.9479167,23.1395156 28.9479167,16 C28.9479167,8.86048437 23.1395156,3.05208333 16,3.05208333 C8.86048438,3.05208333 3.05208333,8.86048437 3.05208333,16 C3.05208333,17.9876771 3.49775521,19.9066042 4.34040104,21.6438021 L4.34040104,21.6438021 L3.88138021,24.2667865 C2.22507813,21.8497083 1.33333333,18.9936042 1.33333333,16 C1.33333333,12.0823958 2.85895313,8.39922917 5.6290625,5.6290625 C8.39922917,2.85895312 12.0823958,1.33333333 16,1.33333333 Z M6.52859896,19.1105938 L12.8886615,25.4707135 L6.38496875,26.6097292 C6.33558333,26.6183802 6.28596875,26.6226198 6.23669792,26.6226198 C6.01085417,26.6226198 5.79165625,26.533474 5.62911979,26.3709375 C5.43111979,26.1729375 5.34197396,25.8908906 5.39027083,25.6150885 L5.39027083,25.6150885 L6.52859896,19.1105938 Z M22.6992292,10.516099 L24.9553177,12.7722448 C25.2909323,13.1078594 25.2909323,13.6519583 24.955375,13.9875729 L24.955375,13.9875729 L14.3958333,24.5471146 L11.5319948,21.6833333 L22.6992292,10.516099 Z M18.011625,7.04388021 C18.3472396,6.70826563 18.8913958,6.70826563 19.2269531,7.04388021 L19.2269531,7.04388021 L21.483901,9.30077083 L10.3166667,20.4680052 L7.45208333,17.6034219 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimatorIcon);
export default __webpack_public_path__ + "static/media/EstimatorIcon.aa992c98d7811505517014493ee14f68.svg";
export { ForwardRef as ReactComponent };